import { Breadcrumbs as SharedBreadcrumbs } from '@ecomm/header'
import { useMemo } from 'react'

export function BreadcrumbsWrapper({
  breadcrumbTitle = '',
  slug
}: {
  readonly breadcrumbTitle?: string | null
  readonly slug: string
}) {
  const steps = useMemo(() => {
    return [{ label: breadcrumbTitle || '', slug }]
  }, [breadcrumbTitle, slug])
  return breadcrumbTitle ? <SharedBreadcrumbs steps={steps} /> : null
}
